<template>
  <v-ons-page>
    <div class="background" />

    <div class="content">
      <v-ons-row class="map-detail-head">
        <v-ons-col
          v-show="isShowDetail && isShowList"
          class="map-back-to-list"
          vertical-align="center"
        >
          <v-ons-button
            class="back-to-top"
            modifier="light back"
            @click="backToList"
          >
            一覧に戻る
          </v-ons-button>

        </v-ons-col>
        <v-ons-col class="map-detail-close">
          <img
            src="~@/assets/images/close_button.svg"
            @click="clearDestinations"
          >
        </v-ons-col>
      </v-ons-row>
      <transition :name="transitionName">
        <destination-detail v-if="isShowDetail" />
        <destination-list v-else-if="isShowList" />
      </transition>

    </div>
  </v-ons-page>
</template>


<script>
import destinationList from './list.vue';
import destinationDetail from './detail.vue';

export default {
  components: {
    destinationList,
    destinationDetail,
  },
  computed: {
    isShowList: ({ $store }) => $store.state.destinationList.isShow,
    isShowDetail: ({ $store }) => $store.state.destinationDetail.isShow,
    transitionName: (vm) => (vm.isShowList ? 'slide' : 'none'),
  },
  methods: {
    clearDestinations() {
      this.$store.dispatch('searchResult/allClearDestinations');
    },
    backToList() {
      this.$store.commit('destinationList/show');
      this.$store.commit('destinationDetail/hide');
      this.$store.commit('searchResult/clearDestination');
    },
  },
};
</script>

<style scoped lang="scss">
.background {
  background: #fff;
}
.map-detail-head {
  padding: 40px 27px;
}
.map-detail-close {
  text-align: right;
}
.slide-enter-active, .slide-leave-active {
  transition: all 0.2s;
  &.destination-detail {
    position: absolute;
    top: 165px;
  }
}
.slide-enter, .slide-leave-to {
  &.destination-lists {
    transform: translateX(-100%);
  }
  &.destination-detail {
    left: 100%;
  }
}
.slide-enter-to, .slide-leave {
  &.destination-lists {
    transform: translateX(0);
  }
  &.destination-detail {
    left: 0;
  }
}

.none-enter-active, .none-leave-active {
  transition: all 0;
  &.destination-detail {
    position: absolute;
    top: 165px;
  }
}

.destination-lists,
.destination-detail {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// panel.vue?6e2a901d